﻿<script setup>
    const router = useRouter();

    const props = defineProps({
        title: String,
        to: String,
        label: String,
        flat: Boolean,
        dense: Boolean,
        disabled: Boolean,
        back: Boolean
    });

    const emit = defineEmits(['click']);

    function click() {
        if (props.back) {
            router.go(-1);
        } else {
            emit('click');
        }
    }
</script>

<template>
    <q-btn 
        :dense="dense"
        :round="!flat"
        :flat="flat"
        :outline="flat"
        :size="flat ? 'md' : 'sm'" 
        color="grey-9" 
        icon="reply" 
        :title="title || 'Cancel'"
        :label="flat ? (label || 'Cancel') : ''"
        @click="click"
        :to="to"
           :disable="disabled"/>
</template>